<template>
  <div class="error">
    <img src="@/assets/images/error-image.svg" />
    <h5>Error 404</h5>
    <p>The page requested by you is unavailable.</p>
    <button class="primary-btn" @click="$router.push({name: 'Dashboard'})">Go to Dashboard</button>
  </div>
</template>

<script>
export default {
  name: 'Error404'
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .error {
    background: $white;
    border-radius: 15px;
    @include custom-flex(center, center, column);
    height: 100%;

    img {
      height: 150px;
    }
    h5 {
      @include highlight-text($secondary, 22px);
      margin-top: 20px;
    }
    p {
      @include normal-text($grey-text, 17px);
      margin: 15px 0;
    }
  }
</style>
